﻿import { useState, useCallback } from 'react';
import { api } from '@/services/api';

export interface Company {
  codice: string;
  descrizione: string;
  [key: string]: unknown;
}

export function useCompanies() {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCompanies = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get<Company[]>(
        'clienti/azienda/elenco',
        { cache: true }
      );
      setCompanies(data || []);
    } catch {
      setCompanies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { companies, loading, fetchCompanies };
}
